import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PurchaseInvalidationDTO } from '../../../types/purchases/invalidation/PurchaseInvalidationDTO';
import { PurchaseInvalidationState } from '../../../types/purchases/invalidation/PurchaseInvalidationState';

const initialForm: PurchaseInvalidationDTO = {
  documentId: null,
  documentTypeCode: null,
  generationCodeToInvalidate: null,
  replacementGenerationCode: null,
  invalidationTypeCode: null,
  comment: null,
};

const initialState: PurchaseInvalidationState = {
  form: initialForm,
  isSubmitting: false,
  formErrors: {},
};

const purchaseInvalidationSlice = createSlice({
  name: 'purchaseInvalidation',
  initialState,
  reducers: {
    setInvalidationField<K extends keyof PurchaseInvalidationDTO>(
      state,
      action: PayloadAction<{ field: K; value: PurchaseInvalidationDTO[K] }>
    ) {
      const { field, value } = action.payload;
      state.form[field] = value;
    },

    setInvalidationForm(state, action: PayloadAction<PurchaseInvalidationDTO>) {
      console.log(action.payload)
        state.form = action.payload;
    },

    setIsSubmitting(state, action: PayloadAction<boolean>) {
      state.isSubmitting = action.payload;
    },

    setInvalidationFormErrors(state, action: PayloadAction<Record<string, string>>) {
      state.formErrors = action.payload;
    },

    clearInvalidationFormErrors(state) {
      state.formErrors = {};
    },

    resetInvalidationForm(state) {
      state.form = { ...initialForm };
      state.formErrors = {};
      state.isSubmitting = false;
    },

    clearSelectedPurchases(state) {
      state.form.documentId = null;
      state.form.documentTypeCode = null;
      state.form.generationCodeToInvalidate = null;
      state.form.replacementGenerationCode = null;
    },

    clearReplacementPurchase(state) {
      state.form.replacementGenerationCode = null;
    },
  },
});

export const {
  setInvalidationField,
  setInvalidationForm,
  setIsSubmitting,
  setInvalidationFormErrors,
  clearInvalidationFormErrors,
  resetInvalidationForm,
  clearSelectedPurchases,
  clearReplacementPurchase,
} = purchaseInvalidationSlice.actions;

export default purchaseInvalidationSlice.reducer;
